function initFileUploads() {
  document.querySelectorAll('.file-upload').forEach((zone) => {
    const input = zone.querySelector('input[type="file"]');
    const prompt = zone.querySelector('.file-prompt');
    const nameDisplay = zone.querySelector('.file-upload__name');
    const errorDisplay = zone.querySelector('.file-upload__error');

    const allowedTypes = (input.getAttribute('allowed') || '').split(',').map((s) => s.trim());

    function isValid(file) {
      const ext = file.name.split('.').pop().toLowerCase();
      return allowedTypes.includes(file.type) || allowedTypes.includes(ext);
    }

    function clearFile() {
      input.value = '';
      nameDisplay.hidden = true;
      errorDisplay.hidden = true;
      zone.classList.remove('file-success', 'file-error');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function showFile(file) {
      const dot = file.name.lastIndexOf('.');
      nameDisplay.innerHTML = `<span class="filename">${file.name.slice(0, dot)}</span>.<span class="extension">${file.name.slice(dot + 1)}</span><button type="button" class="file-clear" aria-label="Remove file">&times;</button>`;
      nameDisplay.querySelector('.file-clear').addEventListener('click', (e) => {
        e.stopPropagation();
        clearFile();
      });
      nameDisplay.hidden = false;
      errorDisplay.hidden = true;
      zone.classList.add('file-success');
      zone.classList.remove('file-error');
    }

    function showError() {
      errorDisplay.hidden = false;
      nameDisplay.hidden = true;
      zone.classList.add('file-error');
      zone.classList.remove('file-success');
    }

    zone.addEventListener('click', (e) => {
      if (e.target !== input && !e.target.closest('.file-clear')) input.click();
    });

    zone.addEventListener('drop', (e) => {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (!file) return;
      const dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
      isValid(file) ? showFile(file) : showError();
    });

    input.addEventListener('change', () => {
      if (input.files[0]) isValid(input.files[0]) ? showFile(input.files[0]) : showError();
    });
  });
}

function applyVinState(input) {
  if (/\s/.test(input.value)) input.value = input.value.replace(/\s/g, '');
  const length = input.value.length;
  input.setCustomValidity(length === 17 ? '' : 'VIN is invalid');
  // Partial VIN shows the inline requirement message (with or without an ATC attempt).
  input.closest('[data-option-field]')?.classList.toggle('vin-incomplete', length > 0 && length !== 17);
}

function initVinInputs() {
  document.querySelectorAll('[data-vin]').forEach((input) => {
    if (input.dataset.vinInit) return;
    input.dataset.vinInit = '';
    input.addEventListener('input', () => applyVinState(input));
  });
}

function validateCheckboxGroups(form) {
  form.querySelectorAll('.checkbox-required').forEach((group) => {
    const checkboxes = [...group.querySelectorAll('input[type="checkbox"]')];
    const anyChecked = checkboxes.some((cb) => cb.checked);
    checkboxes[0]?.setCustomValidity(anyChecked ? '' : 'Please select at least one option.');
  });
}

function initGlobalDragState() {
  let depth = 0;
  document.addEventListener('dragenter', () => {
    if (++depth === 1) document.body.classList.add('is-dragging');
  });
  document.addEventListener('dragleave', () => {
    if (--depth === 0) document.body.classList.remove('is-dragging');
  });
  document.addEventListener('dragover', (e) => e.preventDefault());
  document.addEventListener('drop', (e) => {
    e.preventDefault();
    depth = 0;
    document.body.classList.remove('is-dragging');
  });
}

initFileUploads();
if (document.querySelector('.file-upload')) initGlobalDragState();
initVinInputs();

document.addEventListener('on:product:change', () => {
  initVinInputs();
  initFileUploads();
});

/**
 * Validate required product-option fields for the shared EmbarkAddons gate.
 * The ATC button stays enabled; product-form calls validateAll() on submit,
 * which highlights + scrolls to the first invalid field alongside addons/kit.
 * @returns {{ valid: boolean, invalid: HTMLElement[], message: (string|undefined) }}
 */
function validateProductOptions() {
  const form = document.querySelector('.js-product-form-main');
  if (!form) return { valid: true, invalid: [] };

  validateCheckboxGroups(form);
  // Re-sync VIN validity from the current value — bfcache restores and
  // programmatic fills never fire the input event.
  form.querySelectorAll('[data-vin]').forEach(applyVinState);

  const invalid = [];
  form.querySelectorAll('input, select, textarea').forEach((el) => {
    // Required-addon inputs are validated by their own <required-variant-picker> provider.
    if (el.closest('required-variant-picker')) return;
    if (el.willValidate && !el.checkValidity()) invalid.push(el);
  });
  return { valid: invalid.length === 0, invalid, message: 'Please complete the required fields.' };
}

if (window.EmbarkAddons && document.querySelector('.embark-product-options')) {
  window.EmbarkAddons.register({ validate: validateProductOptions });
}
